// extracted by mini-css-extract-plugin
export default {"welcome_placeholder":"WelcomeMessage_welcome_placeholder__VW1eN","logo_normal":"WelcomeMessage_logo_normal__zTHel"};